import { FormBuilderControlType } from "@common/formbuilder/FormBuilderControlType";
import { IFieldOptions, IFieldGroup } from "../../framework/interfaces/IEntity";
import { IEntityModel, IEntityModelField } from "../../framework/interfaces/IEntityModel";
import { FieldType, ViewType } from "../../framework/core/Enums";
import { MfFormControlComponent } from "../../framework/components/mf-form-control/mf-form-control.component";
import { BehaviorSubject } from "rxjs";

export interface IFormFieldGroup extends IFieldGroup {
  formFields?: Array<FormBuilderControl>;
  hidden?: boolean;
}
export interface IFormBuilderControl {
  id?: any;
  displayName?: any;
  controlType?: FormBuilderControlType;
  bindingValue?: any;
  field?: any;
  show?: Function;
  lookups?: Array<ILookupSelectItem>
  fieldOptions?: IFieldOptions;
  disabled?: boolean;
  customControl?: any;
  requiredAnimation?: boolean;
  validationFailed?: boolean;
  blockSaving?: boolean;
  className?: string;
  disableLookupCache?: boolean;
  nestedControls?: any;
}

export interface ILookupSelectItem {
  label?: string;
  value: any;
  styleClass?: string;
  icon?: string;
  title?: string;
  disabled?: boolean;
  cascadeValue?: any;
  dataItem?: any;
}
export class FormBuilderControl implements IFormBuilderControl {
  private _className: string = "col-xs-12 col-sm-6 col-md-6 col-lg-6";
  private _displayName: string;
  private _maxChars: number;
  private _lookups?: Array<ILookupSelectItem>;
  id?: any;
  controlType?: FormBuilderControlType;
  bindingValue?: any;
  field?: string;
  show?: Function;
  get lookups(): Array<ILookupSelectItem> { return this._lookups }
  set lookups(value: Array<ILookupSelectItem>) {
    this._lookups = value;
    this.lookupsLoadedObserver.next(this);

    if (this.fieldOptions && this.fieldOptions.lookupsLoaded)
      this.fieldOptions.lookupsLoaded(this, this._lookups)
  }
  fieldOptions?: IFieldOptions
  disabled?: boolean;
  customControl?: any;
  requiredAnimation?: boolean;
  validationFailed?: boolean;
  blockSaving?: boolean
  disableLookupCache?: boolean;
  nestedControls?: any;
  public get displayName(): string { return this._displayName };
  public set displayName(value: string) {
    this._displayName = value;
    if (this.formControl) this.formControl.checkChanges();
  };
  public get maxChars(): number { return this._maxChars };
  public set maxChars(value: number) {
    this._maxChars = value;
    if (this.formControl) this.formControl.checkChanges();
  };
  public formControl?: MfFormControlComponent;
 
  public get className(): string {
    if (this.fieldOptions && this.fieldOptions.className) {
      if (typeof (this.fieldOptions.className) == "function") return this.fieldOptions.className();
      else return this.fieldOptions.className;
    }
    return this._className;
  };
  public set className(value: string) {
    this._className = value;
  }
  public lookupsLoadedObserver = new BehaviorSubject(null);

  constructor() { }
  public load(item: IFieldOptions, itemDTO?: IEntityModel, itemDTOField?: IEntityModelField) {
    let control = this;
    while (item.dbField && item.dbField.indexOf(".") != -1) {
      item.dbField = item.dbField.replace(".", "___");
    }
    //item.field = item.dbField;
    control.controlType = new FormBuilderControlType(typeof item.fieldType != 'undefined' ? item.fieldType : (itemDTOField && typeof itemDTOField.fieldType != 'undefined' ? itemDTOField.fieldType : FieldType.Label), null);

    control._displayName = item.name ? item.name : itemDTOField && typeof itemDTOField.displayName != 'undefined' ? itemDTOField.displayName : itemDTOField && itemDTOField.name ? itemDTOField.name : item.field;
    control.bindingValue = item.field;
    control.field = item.field;
    control.customControl = item.customControl;
    control.show = function (scope, auth, instance) {
      if (item.show) return item.show(scope, auth, instance);
      return true;
    };

    if (item.viewType) control.controlType.viewType = item.viewType;
    if (item.fieldType ? item.fieldType == FieldType.Enum : itemDTOField ? itemDTOField.fieldType == FieldType.Enum : false) item.lookups = itemDTO ? itemDTO.enums[item.field].values.map(o => { return { value: o.value, label: o.display } }) : null;
	  if (item.lookups) control.lookups = item.lookups;
	  //if (item.field == "lastName") debugger;
	  if (itemDTOField) {
		  if (itemDTOField.pattern && !item.pattern) item.pattern = itemDTOField.pattern;
		  if (itemDTOField.minLength && !item.minLength) item.minLength = itemDTOField.minLength;
		  if (itemDTOField.maxLength && !item.maxLength) item.maxLength = itemDTOField.maxLength;
	  }
	  if (item.noPattern) item.pattern = null;
	  control.fieldOptions = item;

    return control;
  }
  public changeLookups(values) {
    this.lookups = values;
    this.formControl.filteredLookups.next(this.lookups);
    this.formControl.checkChanges();
  }


  refreshLookups?: Function;
}
